import { render } from "./backgroundSphere.vue?vue&type=template&id=7647be00&scoped=true"
import script from "./backgroundSphere.vue?vue&type=script&lang=js"
export * from "./backgroundSphere.vue?vue&type=script&lang=js"

import "./backgroundSphere.vue?vue&type=style&index=0&id=7647be00&scoped=true&lang=css"

import exportComponent from "/builds/simply-frontend/simply-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7647be00"]])

export default __exports__